import { render, staticRenderFns } from "./inventoryDetails.vue?vue&type=template&id=2769fd54&"
import script from "./inventoryDetails.vue?vue&type=script&lang=js&"
export * from "./inventoryDetails.vue?vue&type=script&lang=js&"
import style0 from "./inventoryDetails.vue?vue&type=style&index=0&id=2769fd54&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports